import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

export type PageContentBlockSizes =
  'small' | 'medium' | 'large' | 'half' | 'third' | 'full';

@Component({
  selector: 'procure-page-content-block',
  templateUrl: './page-content-block.component.html',
  styleUrl: './page-content-block.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageContentBlock {
  @HostBinding('class') get classes(): string {
    return `procure-page-content-block--${this.size}`;
  }

  @Input() size: PageContentBlockSizes = 'medium';
}
